import React, { useContext, useEffect, createContext } from "react";

// project-imports
import { showToast } from "../components/sweet-alert/Sweetalert";
import plans from '../data/Products/ProductData.json'
import {
    CREATE_PRODUCTS_BEGIN,
    CREATE_PRODUCTS_SUCCESS,
    CREATE_PRODUCTS_FAILURE,
    GET_PRODUCTS_BEGIN,
    GET_PRODUCTS_SUCCESS,
    GET_PRODUCTS_FAILURE,
    GLOBAL_SEARCH_EBOOK_SUCCESS,
} from "../constants/actions";
import { getProducts } from "./salesforce_api_context";
import { useBugContext } from "./bug_context";

// third-party
import { useDispatch, useSelector } from "react-redux";

// Create context
export const ProductContext = createContext();

export const ProductProvider = (props) => {

    // Reading store data
    const state = useSelector((state) => state?.products);

    const { bugReportApi } = useBugContext();

    // Reading dispatch from Store
    const dispatch = useDispatch();

    // Constant functions

    // Function to get testimonials
    const fetchProducts = async () => {
        try {
            // Dispatching the action to begin the api calling process
            dispatch({ type: GET_PRODUCTS_BEGIN, payload: true });

            // Calling API to get testimonials 
            // let response = plans || [];
            let response = await getProducts();

            // Dispatching the actions on success
            dispatch({ type: GET_PRODUCTS_SUCCESS, payload: response });

            // Showing the toast message on getting testimonials successfully
            // showToast("success", "Getting testimonials successfully ", true, "bottom-right", false, true, 5000);
        } catch (error) {
            console.log("48 : product_context : Error while getting product data::", error && JSON.stringify(error));

            // Dispatching the actions on error
            dispatch({ type: GET_PRODUCTS_FAILURE, payload: error && error.message });
            bugReportApi("Error while fetching products", `/services/apexrest/product/v1/search?collectionId=products`, "GET", error);

            // Showing the toast message on getting product data unsuccessfully
            showToast("error", (error && error.message) ? "We are unable to get the testimonials data!" : "An error occurred", true, "bottom-right", false, true, 5000);
        }
    };

    // Function to post(add) product
    const submitProducts = async (testimonialPayload) => {

        try {
            // Dispatching the action to begin  the api calling process
            dispatch({ type: CREATE_PRODUCTS_BEGIN, payload: true });

            // Calling API to post product
            let response = [];

            // Dispatching the actions on success
            dispatch({ type: CREATE_PRODUCTS_SUCCESS, payload: response });

            // Showing the toast message on submit product successfully
            showToast("success", "Your product is created Successfully", true, "bottom-right", false, true, 5000);
        } catch (error) {
            console.log("48 : product_context : Error while submitting product::", error && JSON.stringify(error));

            // Dispatching the actions on error
            dispatch({ type: CREATE_PRODUCTS_FAILURE, payload: error && error.message, });

            // Showing the toast message on submitting product unsuccessfully
            showToast("error", (error && error.message) ? "We are unable to creating your product at this moment. Please try again later!" : "An error occurred", true, "bottom-right", false, true, 5000);
        }
    };

    // Fucntion to set filter blogs
    const setFilteredEBooks = (searchTerm) => {

        // Dispatching the actions on success 
        dispatch({ type: GLOBAL_SEARCH_EBOOK_SUCCESS, payload: searchTerm });
    }

    useEffect(() => {
        fetchProducts();
    }, []);

    return (
        <ProductContext.Provider
            value={{ ...state, fetchProducts, submitProducts, setFilteredEBooks }}
        >
            {props.children}
        </ProductContext.Provider>
    );
};
export const useProductContext = () => {
    return useContext(ProductContext);
};
